var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function uploadElement($compile, wsData, cmdiOptions, http, sce) {
        return {
            transclude: true,
            templateUrl: 'views/partials/elements/uploadElement.html',
            link: function (scope, tElement, tAttrs, controller) {
                var divExtension = "";
                scope.title = tAttrs.title;
                cmdiOptions.getDescriptionForOperationNameAndParamName(tAttrs.operationname, tAttrs.parameternametoset).then(function (data) {
                    scope.hoverMessage = data.replace("\n", " ").replace(/\s\s+/g, " ");
                });
                scope.parameterNameToSet = tAttrs.parameternametoset;
                scope.supportedFileExtensions = tAttrs.supportedfileextensions;
                scope.classesToSet = tAttrs.classestoset;
                if (tAttrs.testfile) {
                    var setNumber = 0;
                    wsData.add(setNumber, tAttrs.parameternametoset, tAttrs.testfile);
                    BASWebServices.UploadElementController.handleSuccessfulUpload(tAttrs.testfile, scope, http, sce, null, "", tAttrs.testfile);
                }
                if (tAttrs.usingAudioPlayer != undefined && tAttrs.usingAudioPlayer == "true") {
                    scope.usingAudioPlayer = true;
                }
            }
        };
    }
    BASWebServices.uploadElement = uploadElement;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=uploadElement.js.map